import { render, staticRenderFns } from "./shop_header.vue?vue&type=template&id=7176f34c&scoped=true"
import script from "./shop_header.vue?vue&type=script&lang=js"
export * from "./shop_header.vue?vue&type=script&lang=js"
import style0 from "./shop_header.vue?vue&type=style&index=0&id=7176f34c&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7176f34c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\chenwllCode\\cunxian\\web-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7176f34c')) {
      api.createRecord('7176f34c', component.options)
    } else {
      api.reload('7176f34c', component.options)
    }
    module.hot.accept("./shop_header.vue?vue&type=template&id=7176f34c&scoped=true", function () {
      api.rerender('7176f34c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/design/components/mobilePage/shop_header.vue"
export default component.exports